import React, { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import '../../css/billstyle.css'
import {useDispatch, useSelector } from 'react-redux';
import { fatchQuotationAPI,fatchSignAPI,fatchUserAPI,fatchPhotoAPI,EditQuotationAPI,fatchTearmsAPI,fatchBankAPI} from '../../redux/actionCreation';
import { parseISO, format } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useNavigate } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css'; // Import the styles
import DOMPurify from 'dompurify';
import { Helmet } from 'react-helmet';
import html2pdf from 'html2pdf.js';
import Loader from '../Loader';
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import QuoteEditPop from '../quotation/QuoteEditPop';
// 1. Top par import karein
import { PDFDownloadLink } from '@react-pdf/renderer';
import QuotationPDFTemplate from './QuotationPDFTemplate';
function Quotedesign() {
    //view port set
    useEffect(() => {
        // Update the viewport meta tag when ABCComponent mounts
        const metaTag = document.querySelector('meta[name="viewport"]');
        if (metaTag) {
          metaTag.setAttribute('content', 'width=device-width, initial-scale=0.4, maximum-scale=1.0, user-scalable=yes');
        }
    
        // Clean up function to reset the viewport when ABCComponent unmounts
        return () => {
          if (metaTag) {
            metaTag.setAttribute('content', 'width=device-width, initial-scale=1');
          }
        };
      }, []); // Run only once on component mount
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [loading_update, setLoading_update] = useState(false);
    const dispatchFetchPhoto = useDispatch();
    const [selectedQuotId, setSelectedQuotId] = useState(null);
    const [filteredQuote, setFilteredQuote] = useState([]);
    const ref2 = useRef(null);
    const fetchQutReducers = useSelector(state => state.fetchQutReducers);
    const FeatchTearmsReducers = useSelector(state => state.FeatchTearmsReducers);
    const FetchBankReducers = useSelector(state => state.FetchBankReducers);
    const signatures = useSelector((state) => state.fetchReducers);
    const hasSignature = signatures.data.some(signature => signature.signature_data);
    const fetchcompanyLogo = useSelector(state => state.fetchcompanyLogo);
    const error_edit = useSelector(state => state.EditQuotationReducers.error?.edit_quotation_errors) ?? null;

    const fetchUserReducres = useSelector(state => state.fetchUserReducres);
    const email = fetchUserReducres.data ? fetchUserReducres.data.email : null;
    const company_name = fetchUserReducres.data ? fetchUserReducres.data.company_name : null;
    const phone_number = fetchUserReducres.data ? fetchUserReducres.data.phone_number : null;
    const phone_number_2 = fetchUserReducres.data ? fetchUserReducres.data.phone_number_2 : null;
    const company_website = fetchUserReducres.data ? fetchUserReducres.data.company_website : null;
    const company_GST = fetchUserReducres.data ? fetchUserReducres.data.company_GST : null;
    const company_add = fetchUserReducres.data ? fetchUserReducres.data.company_add : null;
    const navigate = useNavigate();
    useEffect(()=>{
        if(!localStorage.getItem('tokan')){
            navigate('/login');
        }
    }, []);

    useEffect(() => {
        const fetchDataUser = async () => {
            try {
                const res = await dispatch(fatchUserAPI());
            } catch (error) {
                console.error('Error fetching Company Details data:', error);
            }
        };
        fetchDataUser();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await dispatch(fatchQuotationAPI());
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.log('Error fetching data:', error);
            }
        };
        fetchData(); // Call the async function
    }, []);

    useEffect(() => {
        const fetchDataSign = async () => {
            try {
                const res = await dispatch(fatchSignAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataSign(); // Call the async function
    }, []);

    useEffect(() => {
        const fetchPhoto = async () => {
            try {
              const res = await dispatchFetchPhoto(fatchPhotoAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchPhoto(); // Call the async function
    }, []);
    
    useEffect(() => {
        const fetchBank = async () => {
            try {
                const res = await dispatch(fatchBankAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchBank(); // Call the async function
    }, []);

    useEffect(() => {
        const fetchDataTearms = async () => {
            try {
                const res = await dispatch(fatchTearmsAPI());
                // Process the result if needed
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataTearms(); // Call the async function
    }, []);

    // Update Quotation Function
    const [formData, setFormData] = useState({  
        name: '',
        phone_number: '',
        quotation_date: '',
        customer_address: '',
        service_name: '',
        c_gst:'',
        from_state: '',      // Added missing 'from_state'
        from_city: '',
        from_address: '',    // Added missing 'from_address'
        to_state: '',        // Added missing 'to_state'
        to_city: '',  // Added missing 'to_address'
        to_address: '',  
        shift_start_date: '',
        shift_end_date: '',    
        select_floor: '',    // Added missing 'select_floor'
        select_lift: '',     // Added missing 'select_lift'
        select_to_floor: '',    // Added missing 'select_floor'
        select_to_lift: '',     // Added missing 'select_lift'
        shift_items: '',
        transportation_charge: '',
        packing_charge: '',
        unpacking_charge: '',
        loading_charge: '',
        unloading_charge: '',
        insurance_charge: '',
        service_charge: '',
        storage_charge: '',
        other_charge: '',
        total_charge: '',
        sgst_per: '',
        sgst_charge: '',
        cgst_per: '',
        cgst_charge: '',
        gst_per: '',
        gst_charge: '',
      });

         // Function to calculate total of specified fields
   const calculateTotal = () => {
    const {
        transportation_charge,
        packing_charge,
        unpacking_charge,
        loading_charge,
        unloading_charge,
        insurance_charge,
        storage_charge,
        other_charge
    } = formData;

    const total =
      parseFloat(transportation_charge) +
      parseFloat(packing_charge) +
      parseFloat(unpacking_charge) +
      parseFloat(loading_charge) +
      parseFloat(unloading_charge) +
      parseFloat(insurance_charge) +
      parseFloat(storage_charge) +
      parseFloat(other_charge);
    return total;
  };

     // Function to calculate SGST charge based on total and cgst_per
     const calculateSGSTCharge = (total, sgstPercentage) => {
        return (total * parseFloat(sgstPercentage)) / 100;
    };

    // Function to calculate CGST charge based on total and cgst_per
    const calculateCGSTCharge = (total, cgstPercentage) => {
        return (total * parseFloat(cgstPercentage)) / 100;
    };
    
    // Function to calculate IGST charge based on total and gst_per
    const calculateGSTCharge = (total, gstPercentage) => {
        return (total * parseFloat(gstPercentage)) / 100;
    };
  
    // useEffect to watch for changes in relevant fields and recalculate charges
    useEffect(() => {
        const total = calculateTotal();
        const gstCharge = calculateGSTCharge(total, formData.gst_per);
        const cgstCharge = calculateCGSTCharge(total, formData.cgst_per);
        const sgstCharge = calculateSGSTCharge(total, formData.sgst_per);
        // Update state with the calculated values
        setFormData((prevData) => ({
        ...prevData,
        total_charge:total.toFixed(2),
        gst_charge: gstCharge.toFixed(2), // Adjust decimal places as needed
        cgst_charge: cgstCharge.toFixed(2), // Adjust decimal places as needed
        sgst_charge: sgstCharge.toFixed(2), // Adjust decimal places as needed
        }));
    }, [
        formData.transportation_charge,
        formData.packing_charge,
        formData.unpacking_charge,
        formData.loading_charge,
        formData.unloading_charge,
        formData.insurance_charge,
        formData.storage_charge,
        formData.other_charge,
        formData.sgst_per,
        formData.cgst_per,
        formData.gst_per,
    ]);
  
    useEffect(() => {
        setFilteredQuote(fetchQutReducers.data);
  }, [fetchQutReducers.data]); 

const formatDate = (dateString) => {
    // Agar dateString khali hai, null hai ya "NA" hai, toh khali string return karo
    if (!dateString || dateString === "NA" || dateString === "" || dateString === "0000-00-00") {
        return ""; 
    }

    const date = new Date(dateString);

    // Check karo ki date valid hai ya nahi (RangeError se bachne ke liye)
    if (isNaN(date.getTime())) {
        return "";
    }

    try {
        const formattedDate = date.toISOString().split('T')[0];
        return formattedDate;
    } catch (error) {
        console.error("Format Date Error:", error);
        return "";
    }
};

    
       // Function to handle link click
    const UpdateQuotationClick = (QuoteId) => {
        setSelectedQuotId(QuoteId);
        const selectedQuote = fetchQutReducers.data.find(quotation => quotation.id === QuoteId);
        if (selectedQuote) {
                const formattedDate = formatDate(selectedQuote.quotation_date);
                const shift_start_date = formatDate(selectedQuote.shift_start_date);
                const shift_end_date = formatDate(selectedQuote.shift_end_date);
                const defaultTime = new Date();
                defaultTime.setHours(0, 0, 0, 0);
            setFormData({
                ...formData,
                name: selectedQuote.name,
                phone_number: selectedQuote.phone_number,
                quotation_date: formattedDate ? new Date(formattedDate + 'T00:00:00') : defaultTime,
                service_name: selectedQuote.service_name,
                c_gst: selectedQuote.c_gst,
                customer_address: selectedQuote.customer_address,
                from_state: selectedQuote.from_state,
                from_city: selectedQuote.from_city,
                from_address: selectedQuote.from_address,
                to_state: selectedQuote.to_state,
                to_city: selectedQuote.to_city,
                to_address: selectedQuote.to_address,
                shift_start_date: shift_start_date ? new Date(shift_start_date + 'T00:00:00') : defaultTime,
                shift_end_date: shift_end_date ? new Date(shift_end_date + 'T00:00:00') : defaultTime,
                select_floor: selectedQuote.select_floor,
                select_lift: selectedQuote.select_lift,
                select_to_floor: selectedQuote.select_to_floor,
                select_to_lift: selectedQuote.select_to_lift,
                shift_items: selectedQuote.shift_items,
                transportation_charge: selectedQuote.transportation_charge,
                packing_charge: selectedQuote.packing_charge,
                unpacking_charge: selectedQuote.unpacking_charge,
                loading_charge: selectedQuote.loading_charge,
                unloading_charge: selectedQuote.unloading_charge,
                insurance_charge: selectedQuote.insurance_charge,
                service_charge: selectedQuote.service_charge,
                storage_charge: selectedQuote.storage_charge,
                other_charge: selectedQuote.other_charge,
                sgst_per: selectedQuote.sgst_per,
                sgst_charge: selectedQuote.sgst_charge,
                cgst_per: selectedQuote.cgst_per,
                cgst_charge: selectedQuote.cgst_charge,
                gst_per: selectedQuote.gst_per,
                gst_charge: selectedQuote.gst_charge,
              });
        } else {
            console.log("Quotation not found");
        }
    };


      const imageUrl = `https://app.packersbilling.in/api/${fetchcompanyLogo.data?.[0]?.path}`;
     const [base64URL, setBase64URL] = useState('');
    useEffect(() => {
      const fetchImage2 = async () => {
      try {
          const response = await fetch(imageUrl);
          if (!response.ok) {
          throw new Error(`Failed to fetch image. Status: ${response.status}`);
          }
          const blob = await response.blob();
          const reader = new FileReader();
          reader.onloadend = () => {
          const base64 = reader.result;
          setBase64URL(base64);
          };
          reader.readAsDataURL(blob);
      } catch (error) {
          console.error('Error fetching or converting the image:', error);
      }
      };

      fetchImage2();
  }, [imageUrl]);

     // State for From Location
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [cities, setCities] = useState([]);
  
    // State for To Location
    const [selectedToState, setSelectedToState] = useState(null);
    const [selectedToCity, setSelectedToCity] = useState(null);
    const [toCities, setToCities] = useState([]);
  
    // Get all Indian states
    const states = State.getStatesOfCountry("IN").map((state) => ({
      value: state.isoCode,
      label: state.name,
    }));
  
    // Load Cities when Editing
    useEffect(() => {
      if (formData.from_state) {
        const stateObject = states.find((state) => state.value === formData.from_state);
        setSelectedState(stateObject);
  
        const filteredCities = City.getCitiesOfState("IN", formData.from_state).map((city) => ({
          value: city.name,
          label: city.name,
        }));
  
        setCities(filteredCities);
  
        if (formData.from_city) {
          const cityObject = filteredCities.find((city) => city.value === formData.from_city);
          setSelectedCity(cityObject);
        }
      }
    }, [formData.from_state, states]);
  
    useEffect(() => {
      if (formData.to_state) {
        const stateObject = states.find((state) => state.value === formData.to_state);
        setSelectedToState(stateObject);
  
        const filteredCities = City.getCitiesOfState("IN", formData.to_state).map((city) => ({
          value: city.name,
          label: city.name,
        }));
  
        setToCities(filteredCities);
  
        if (formData.to_city) {
          const cityObject = filteredCities.find((city) => city.value === formData.to_city);
          setSelectedToCity(cityObject);
        }
      }
    }, [formData.to_state, states]);
  
//  const handleDownloadPdf = () => {
//         const element = document.getElementById('content-to-pdf');
//         html2pdf(element, {
//           margin: [8, 5, 20, 5,],
//           filename: 'quotation.pdf',
//           image: { type: 'jpeg', quality: 1 },
//           html2canvas: { scale: 2 },
//           jsPDF: { unit: 'mm', format: 'a3', orientation: 'portrait' },
//         });
//       };

// const handleDownloadPdf = () => {
//   const element = document.getElementById('content-to-pdf');

//   // Step 1: Forcefully scroll to top (Zaroori hai blank space hatane ke liye)
//   window.scrollTo(0, 0);

//   const options = {
//     margin: [5, 5, 5, 5], // Top, Left, Bottom, Right
//     filename: 'quotation.pdf',
//     image: { type: 'jpeg', quality: 0.98 },
//     html2canvas: {
//       scale: 2,
//       useCORS: true,
//       scrollY: 0,           // Force canvas starting point to top
//       scrollX: 0,
//       windowHeight: element.scrollHeight, // Content ki actual height lo
//       logging: false,
//     },
//     jsPDF: { unit: 'mm', format: 'a3', orientation: 'portrait' },
//     pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
//   };

//   // Step 2: Thoda sa delay (100ms) taaki scroll complete ho jaye
//   setTimeout(() => {
//     html2pdf().set(options).from(element).save();
//   }, 100);
// };

const handleDownloadPdf = async () => {
  const element = document.getElementById('content-to-pdf');
  if (!element) {
    alert("Quotation content not found!");
    return;
  }
  
  window.scrollTo(0, 0);

  const options = {
    margin: [5, 5, 5, 5],
    filename: 'quotation.pdf',
    image: { type: 'jpeg', quality: 0.95 }, 
    html2canvas: { 
      scale: 1.5, 
      useCORS: true, 
      scrollY: 0, 
      windowHeight: element.scrollHeight 
    },
    jsPDF: { unit: 'mm', format: 'a3', orientation: 'portrait', compress: true }
  };

  try {
    const pdfBlob = await html2pdf().set(options).from(element).output('blob');
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isMobile) {
      const reader = new FileReader();
      reader.readAsDataURL(pdfBlob); 
      reader.onloadend = async function() {
        const base64data = reader.result;

        const userAction = window.confirm("Do you want to SHARE this PDF? \n(Click 'Cancel' to DOWNLOAD)");

        if (userAction && navigator.share) {
          try {
            const file = new File([pdfBlob], 'quotation.pdf', { type: 'application/pdf' });
            await navigator.share({
              files: [file],
              title: 'Quotation',
              text: 'Packers Billing Quotation',
            });
          } catch (err) {
            // Share fail hone par safe download trigger karein
            triggerAndroidDownload(base64data, 'quotation.pdf');
          }
        } else {
          // DOWNLOAD trigger karein
          triggerAndroidDownload(base64data, 'quotation.pdf');
        }
      }
    } else {
      // PC Logic
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = 'quotation.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
    alert("Something went wrong while generating PDF.");
  }
};

// Common Helper (Isse apne component mein kahin bhi rakh dein)
const triggerAndroidDownload = (base64data, fileName) => {
  const link = document.createElement('a');
  link.href = base64data;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  return (
    <>
    {loading && <div className='text-center mt-4'>
        <Loader />
    </div>}
    {!loading && (
    <Row>
        {fetchQutReducers.data && Array.isArray(fetchQutReducers.data) && fetchQutReducers.data.length > 0 ? (
            [...fetchQutReducers.data].reverse().slice(0,1).map(item => (
        <div key={item.id} className="container-fluid invoice-container"> 
            <div id='content-to-pdf'>
                <header>
                    <div className="row align-items-center gy-3">
                        <div className="col-sm-3 text-center text-sm-start">
                            <div>
                                {base64URL ? (
                                    <div>
                                    <img src={base64URL} alt="logo" className='logo'/>
                                    </div>
                                ) : (
                                    <Link to="/update-company" className='btn btn-primary'>Add Logo</Link>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-9 text-center text-sm-end">
                            <h4 className="mb-1">{company_name}</h4>
                            <p className="mb-1"><i className='fa fa-map-marker-alt'></i> {company_add}</p>
                            <div className='d-flex align-items-center justify-content-end mb-1'>
                                <p className="mb-0 mx-2 email"><i className='fa fa-envelope'></i> {email}</p>
                                <p className="mb-0"><i className='fa fa-phone'></i> +91 {phone_number} {phone_number_2 && ( // Check if phone_number_2 exists
                                    <span>, {phone_number_2}</span>
                                )}</p>
                            </div>
                            <div className='d-flex align-items-center justify-content-end'>
                                {company_GST && ( // Check if company_GST exists
                                    <p className="mb-0 mx-2"><i className='fa fa-file'></i> GSTIN : {company_GST}</p>
                                )}
                                {company_website && ( // Check if company_GST exists
                                    <p className="mb-0 text-lowercase"><i className='fa fa-globe-americas'></i> {company_website}</p>
                                )}
                            
                            </div>
                        </div>
                    </div>
                    <hr className='mt-2'/>
                </header>
                <main>
                    <div className="row gy-3 bg-red">
                    <div className="col mt-2 mb-2"> <strong>Quotation Number:</strong> <span>{item.quotation_number}</span> </div>
                    <div className="col text-sm-center mt-2 mb-2"> <strong>Service :</strong> <span>{item.service_name}</span> </div>
                    <div className="col text-sm-end mt-2 mb-2"> <strong>Quotation Date:</strong> <span>{format(parseISO(item.quotation_date), 'dd-MM-yyyy')}</span> </div>
                    </div>
                    <hr className='mb-2 mt-0'/>
                    <div className="row">
                        <div className="col-sm-3">
                            <strong className='mb-1 d-block'>Customer Name :</strong>
                            <p>{item.name}</p>
                        </div>
                        <div className="col-sm-2 text-end">
                            <strong className='mb-1 d-block'>Customer Mo :</strong>
                            <p>{item.phone_number}</p>
                        </div>

                        <div className="col-sm-2 text-end">
                            <strong className='mb-1 d-block'>Start Date :</strong>
                            {/* <p>{format(parseISO(item.shift_start_date), 'dd-MM-yyyy')}</p> */}
                            <p>{(() => {
                                try {
                                return format(parseISO(item.shift_start_date), 'dd-MM-yyyy');
                                } catch (error) {
                                console.error('Error parsing date:', item.shift_start_date);
                                return 'NA';
                                }
                            })()}</p>
                        </div>

                        <div className="col-sm-2 text-end">
                            <strong className='mb-1 d-block'>End Date :</strong>
                            {/* <p>{format(parseISO(item.shift_end_date), 'dd-MM-yyyy')}</p> */}
                            <p>{(() => {
                                try {
                                return format(parseISO(item.shift_end_date), 'dd-MM-yyyy');
                                } catch (error) {
                                console.error('Error parsing date:', item.shift_end_date);
                                return 'NA';
                                }
                            })()}</p>
                        </div>

                        <div className="col-sm-3">
                            <strong className='mb-1 d-block'>Customer GST No. :</strong>
                            <p>{item.c_gst}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-9">
                            <strong className='mb-1 d-block'>Customer Address :</strong>
                            <p>{item.customer_address}</p>
                        </div>
                        
                    </div>
                        <div>
                            <hr className='mt-1 mb-2 border-1 border-black opacity-9'></hr>
                        </div>
                    <div className="row">
                        
                            <div className="col-sm-2">
                                <strong className='mb-1 d-block'>From State :</strong>
                                <p>{item.from_state}</p>
                            </div>

                            <div className="col-sm-2">
                                <strong className='mb-1 d-block'>From City :</strong>
                                <p>{item.from_city}</p>
                            </div>
                            <div className="col-sm-3">
                                <strong className='mb-1 d-block'>From Address :</strong>
                                <p>{item.from_address}</p>
                            </div>
                            <div className="col-sm-2">
                                <strong className='mb-1 d-block'>Floor :</strong>
                                <p>{item.select_floor}</p>
                             </div>

                            <div className="col-sm-3">
                                <strong className='mb-1 d-block'>Lift Availability :</strong>
                                <p>{item.select_lift}</p>
                            </div>
                    </div>
                        
                         <div>
                            <hr className='mt-1 mb-2 border-1 border-black opacity-9'></hr>
                        </div>
                        <div className="row">
                            <div className="col-sm-2">
                                <strong className='mb-1 d-block'>To State :</strong>
                                <p>{item.to_state}</p>
                            </div>

                            <div className="col-sm-2">
                                <strong className='mb-1 d-block'>To City :</strong>
                                <p>{item.to_city}</p>
                            </div>
                            <div className="col-sm-3">
                                <strong className='mb-1 d-block'>To Address :</strong>
                                <p>{item.to_address}</p>
                            </div>
                            <div className="col-sm-2">
                                <strong className='mb-1 d-block'>Floor :</strong>
                                <p>{item.select_to_floor}</p>
                             </div>

                            <div className="col-sm-3">
                                <strong className='mb-1 d-block'>Lift Availability :</strong>
                                <p>{item.select_to_lift}</p>
                            </div>
                        </div>
                         <div>
                            <hr className='mt-1 mb-2 border-1 border-black opacity-9'></hr>
                        </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <strong className='mb-1 d-block'>Shifting Items :</strong>
                            <p>{item.shift_items}</p>
                        </div>
                    </div>
                    
                    <div className="table-responsive quote_charge">
                    <table className="table table-bordered text-1 mb-3">
                        <tbody>
                            <tr className="bg-light">
                                <td colspan="6" className='pt-2 pb-2 pr-1 pl-2 text-center text-white'><strong>Shifting Charges</strong></td>
                            </tr>

                            <tr>
                                <td><strong>Freight Charge</strong></td>
                                <td><b>{item.enter_total_amt}</b></td>
                            </tr>

                            <tr>
                                <td><strong>Transportation Charge</strong></td>
                                <td>{item.transportation_charge}</td>
                            </tr>

                            <tr>
                                <td><strong>Packing Charge</strong></td>
                                <td >{item.packing_charge}</td>
                            </tr>
                            
                            <tr>
                                <td><strong>Unpacking Charge</strong></td>
                                <td >{item.unpacking_charge}</td>
                            </tr>

                            <tr>
                                <td><strong>Loading Charge</strong></td>
                                <td >{item.loading_charge}</td>
                            </tr>
                            
                            <tr>
                                <td><strong>Unloading Charge</strong></td>
                                <td >{item.unloading_charge}</td>
                            </tr>

                            <tr>
                                <td><strong>Insurance Charge</strong></td>
                                <td >{item.insurance_charge}</td>
                            </tr>

                            <tr>
                                <td><strong>Storage Charge</strong></td>
                                <td >{item.storage_charge}</td>
                            </tr>
                            
                            <tr>
                                <td><strong>Service Charge</strong></td>
                                <td >{item.service_charge}</td>
                            </tr>

                            <tr>
                                <td><strong>Other Charge</strong></td>
                                <td >{item.other_charge}</td>
                            </tr>
                            
                            <tr className="bg-light2">
                                <td className='total_amount'><strong>Sub Total</strong></td>
                                <td className='total_amount'><strong><i className='fa fa-indian-rupee'></i> {item.total}</strong></td>
                            </tr>

                                {/* 1. SGST Row: Tabhi dikhega jab type CGST/SGST ho aur setting "Without" na ho */}
                                    {(item.gst_hide_show === "GST Charge Show" || item.gst_hide_show === "GST Included in Freight Charge") && 
                                    item.gst_type === "CGST/SGST" && (
                                        <tr>
                                            <td><strong>SGST Charge({parseFloat(item.gst_per) / 2}%)</strong></td>
                                            <td>
                                                {item.gst_hide_show === "GST Included in Freight Charge" ? (
                                                    <strong>Included</strong>
                                                ) : (
                                                    <><i className='fa fa-indian-rupee'></i> {item.sgst_charge}</>
                                                )}
                                            </td>
                                        </tr>
                                    )}

                                    {/* 2. CGST Row: Tabhi dikhega jab type CGST/SGST ho aur setting "Without" na ho */}
                                    {(item.gst_hide_show === "GST Charge Show" || item.gst_hide_show === "GST Included in Freight Charge") && 
                                    item.gst_type === "CGST/SGST" && (
                                        <tr>
                                            <td><strong>CGST Charge({parseFloat(item.gst_per) / 2}%)</strong></td>
                                            <td>
                                                {item.gst_hide_show === "GST Included in Freight Charge" ? (
                                                    <strong>Included</strong>
                                                ) : (
                                                    <><i className='fa fa-indian-rupee'></i> {item.cgst_charge}</>
                                                )}
                                            </td>
                                        </tr>
                                    )}

                                    {/* 3. IGST Row: Tabhi dikhega jab type IGST ho aur setting "Without" na ho */}
                                    {(item.gst_hide_show === "GST Charge Show" || item.gst_hide_show === "GST Included in Freight Charge") && 
                                    item.gst_type === "IGST" && (
                                        <tr>
                                            <td><strong>IGST Charge ({item.gst_per}%)</strong></td>
                                            <td>
                                                {item.gst_hide_show === "GST Included in Freight Charge" ? (
                                                    <strong>Included</strong>
                                                ) : (
                                                    <><i className='fa fa-indian-rupee'></i> {item.igst_charge}</>
                                                )}
                                            </td>
                                        </tr>
                                    )}

                            <tr className="bg-light">
                                <td className='total_amount text-white'><strong>Grand Total</strong></td>
                                <td className='total_amount text-white'><strong><i className='fa fa-indian-rupee'></i> {item.total_amount}</strong></td>
                            </tr>
                            <tr>
                                <td className='' colspan="6"><strong>Notes: </strong>{item.Notes}</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                    
                    <div className='d-flex align-items-center justify-content-between'>
                        <div>
                            <h4 className="text-3 mt-0 mb-1">Bank Details:</h4>
                                    {FetchBankReducers && Array.isArray(FetchBankReducers.data) && FetchBankReducers.data.length > 0 ? (
                                    [...FetchBankReducers.data].reverse().map(item => (
                                    <div key={item.id} class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-0">
                                        
                                        <div class="d-flex justify-content-between align-items-center mt-3">
                                            <p class="text-dark profile_name">Account Holder Name :</p> <h6 class="text-dark profile_name_data mx-2">{item.account_holder_name}</h6>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <p class="text-dark profile_name">Bank Name :</p>
                                            <h6 class="text-dark profile_name_data mx-2">{item.bank_name}</h6>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <p class="text-dark profile_name">Account Number:</p>
                                            <h6 class="text-dark profile_name_data mx-2">{item.account_number}</h6>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <p class="text-dark profile_name">IFFC Code :</p>
                                            <h6 class="text-dark profile_name_data mx-2">{item.iffc_code}</h6>
                                        </div>
                                    </div>
                                    ))
                                    ) : (
                                        <div className='text-left not_data mt-3 mb-3'>
                                            <Link to="/update-company" className='btn btn-primary'>Add Bank Details</Link>
                                        </div>
                                    )} 
                                </div>
                                <div className='text-end'>
                                    <h4 className="text-3 mt-4 stemp"><strong>For :</strong> {company_name}</h4>
                                    {[...signatures.data].map((signature, index) => (
                                        <img key={index} src={signature.signature_data} alt={`Signature ${index + 1}`} className='sign-size' />
                                    ))}
                                    {!hasSignature && (
                                        <Link to="/update-company" className='d-print-none btn btn-primary'>
                                            Add Sign
                                        </Link>
                                    )}
                                    <p className='mb-0 stemp'>Authorized Signature</p>
                                </div>
                            </div>

                            <div className='d-flex align-items-center justify-content-between'>
                                <div>
                                    <h4 className="text-3 mt-3">Terms and conditions:</h4>
                                    {FeatchTearmsReducers && Array.isArray(FeatchTearmsReducers.data) && FeatchTearmsReducers.data.length > 0 ? (
                                    [...FeatchTearmsReducers.data].reverse().map(item => (
                                        <h6 className="text-dark profile_name_data_terms printpage" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.tearms) }} />
                                        ))
                                        ) : (
                                            <div className='text-center not_data mt-3'>
                                            <Link to="/update-company" className='d-print-none btn btn-primary mb-3'>Add Tearms+</Link>
                                            </div>
                                        )} 
                                </div>
                            </div>
                </main>
            </div>
            <div className="text-center invoice_design">
                {/* <button
                    onClick={() => item && UpdateQuotationClick(item.id)}
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#staticBackdropQuote"
                    aria-controls="staticBackdropQuote" className='btn btn-info bill_btn pt-2 pb-2 d-print-none'>
                    Edit
                </button>

                <div className="btn-group btn-group-sm d-print-none">
                    <a href="javascript:window.print()" className="btn btn-info quot_btn pt-2 pb-2"><i className="fa fa-print"></i> Print & Download</a> 
                </div> */}

                {/* <PDFDownloadLink
                    document={
                        <QuotationPDFTemplate 
                            item={item} 
                            company={{ company_name, company_add, email, phone_number, base64URL, company_GST }}
                            bankData={FetchBankReducers.data || []}
                            signatures={signatures.data || []}
                            terms={FeatchTearmsReducers.data || []}
                            />
                        }
                        fileName={`Quotation_${item.quotation_number}.pdf`}
                        className="btn btn-info bill_btn pt-2 pb-2 d-print-none"
                        >
                        {({ loading }) => (loading ? 'Generating...' : 'Download as PDF')}
                </PDFDownloadLink> */}

                <button
                onClick={handleDownloadPdf}
                type="button"
                className='btn btn-info bill_btn pt-2 pb-2 d-print-none'>
                    Download as PDF
                </button>

                <Link class="btn btn-info plus_btn text-white pt-2 pb-2 d-print-none" to="/quotationList-list">Done</Link>
            </div>
        </div>
        ))
        ): (
            <div className='text-center not_data mt-3'>
                <i class="fa-solid fa-triangle-exclamation"></i>
                <p>No data available</p>
            </div>
        )}
    </Row>
    )}
        {/* Popup Component - All Logic is inside this */}
        <QuoteEditPop QuoteId={selectedQuotId} allData={fetchQutReducers.data} />
    </>
  )
}

export default Quotedesign